import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToolsRoutingModule } from './tools-routing.module';
import { SvgEditorComponent } from './components/svg-editor/svg-editor.component';
import { LottieEditorComponent } from './components/lottie-editor/lottie-editor.component';
import { ColorPickerDirective } from 'ngx-color-picker';
import { FormsModule } from '@angular/forms';
import { BackgroundRemoverComponent } from './components/background-remover/background-remover.component';
import { FormValidatorComponent } from "../../../../../common/components/form-validator/form-validator.component";
import { CaptionGeneratorComponent } from './components/caption-generator/caption-generator.component';
import { ResizeImageComponent } from './components/resize-image/resize-image.component';
import { MergeImageComponent } from './components/merge-image/merge-image.component';
import { MergeGridComponent } from './components/merge-grid/merge-grid.component';
import { ImageGenerationComponent } from './components/image-generation/image-generation.component';
import { ImageUpscalarComponent } from './components/image-upscalar/image-upscalar.component';
import { ImagePlagiarismCheckerComponent } from './components/image-plagiarism-checker/image-plagiarism-checker.component';
import { ImageColorizeComponent } from './components/image-colorize/image-colorize.component';
import { NoRecordFoundComponent } from "../../../../../shared/components/no-record-found/no-record-found.component";
import { SvgCanvasPreviewComponent } from "../../../../../shared/components/svg-canvas-preview/svg-canvas-preview.component";
import { SvgCanvasComponent } from "../../../../../shared/components/svg-canvas/svg-canvas.component";
import { SharedModule } from '../../../../../shared/shared-module';

@NgModule({
  declarations: [
    SvgEditorComponent,
    LottieEditorComponent,
    BackgroundRemoverComponent,
    CaptionGeneratorComponent,
    ResizeImageComponent,
    MergeImageComponent,
    MergeGridComponent,
    ImageGenerationComponent,
    ImageUpscalarComponent,
    ImagePlagiarismCheckerComponent,
    ImageColorizeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerDirective,
    SharedModule,
    ToolsRoutingModule,
    FormValidatorComponent,
    NoRecordFoundComponent,
    SvgCanvasPreviewComponent,
    SvgCanvasComponent
]
})
export class ToolsModule { }
